export default {
    GET_ACTIVITIES: "[zina_flow][activity] get all activity",
    GET_ACTIVITIES_SUCCESS: "[zina_flow][activity] get all activity SUCCESS",
    GET_ACTIVITIES_FAIL: "[zina_flow][activity] get all activity FAIL",

    UPDATE_PAGINATION: "[zina_flow][activity] update activity pagination",
    CHANGE_PAGE: "[zina_flow][activity] change activity page",
    FILTER_LIST: "[zina_flow][activity] change activity filters",

    GET_ACTIVITY_DETAIL: "[zina_flow][activity] get activity detail",
    GET_ACTIVITY_DETAIL_SUCCESS: "[zina_flow][activity] get activity detail SUCCESS",
    GET_ACTIVITY_DETAIL_FAIL: "[zina_flow][activity] get activity detail FAIL"
};
